import { Api } from '../api';
import { statements } from '../endpoints';
import type { StatementEntity, StatementFile, StatementSearchParams } from './models';

export class StatementsApi extends Api {
  static getStatements = (searchParams: StatementSearchParams, signal?: AbortSignal) => {
    const params = {
      AccountId: searchParams.AccountId,
      From: searchParams.DateFrom,
      To: searchParams.DateTo,
    };

    return this.get<StatementEntity[]>({ url: statements.getStatements(), queryParams: params, signal });
  };

  static downloadStatement = async (statementId: string, signal?: AbortSignal) =>
    await this.get<StatementFile>({
      url: statements.downloadStatement(),
      queryParams: { statementId },
      headers: { Accept: 'application/pdf' },
      signal,
    });
}
